import ClientConfig from 'common/debug/client-config';
import { forNamespace } from 'common/lib/util/i18n';
import { Popover, PopoverProps } from 'components/popover';
import { FREE_TEAMS_OUT_OF_SPACE_POPOVER } from 'modules';
import * as React from 'react';

import styles from './closed-boards-dialog.less';

const format = forNamespace('closed boards dialog');
const formatForRoot = forNamespace('');
const isDesktop = ClientConfig.get('appId') === 'desktop';

interface FreeTeamProps {
  name: string;
  upgradeUrl: string;
}

interface FreeTeamsOutOfSpacePopoverProps {
  teams: FreeTeamProps[];
  shouldRenderWithPopoverComponent?: boolean;
  target?: PopoverProps['target'];
}

const FreeTeamOutOfSpace = (props: FreeTeamProps) => (
  <tr className={styles.row}>
    <td className={styles.name}>{props.name}</td>
    {!isDesktop ? (
      <td className={styles.link}>
        <a href={props.upgradeUrl}>{format('upgrade team')}</a>
      </td>
    ) : null}
  </tr>
);

const FreeTeamsOutOfSpacePopover = (props: FreeTeamsOutOfSpacePopoverProps) => {
  const { teams, shouldRenderWithPopoverComponent, target } = props;
  const inner = (
    <table className={styles.cbdtlContainer}>
      <tbody>
        {teams.map((team) => (
          <FreeTeamOutOfSpace key={team.upgradeUrl} {...team} />
        ))}
      </tbody>
    </table>
  );
  if (shouldRenderWithPopoverComponent) {
    return (
      <Popover
        name={FREE_TEAMS_OUT_OF_SPACE_POPOVER}
        target={target}
        title={formatForRoot('free teams out of space popover')}
      >
        {() => <div className={styles.popoverContent}>{inner}</div>}
      </Popover>
    );
  } else {
    return inner;
  }
};

export default FreeTeamsOutOfSpacePopover;



// WEBPACK FOOTER //
// ./app/common/components/closed-boards-dialog/free-teams-out-of-space-popover.tsx